import { useMemo } from 'react';
import { useTranslation } from '@frontend/i18n';
import { AudienceTray } from '../audience-tray/audience-tray';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = {
  cancelCreateList: () => void;
  cancelEditList: () => void;
};

export const RecipientsViewHeader = ({ cancelCreateList, cancelEditList }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { mode } = useAudienceTray();

  const title = useMemo(() => {
    if (mode === 'recipients-edit-list') return t('Edit List');
    if (mode === 'recipients-select-list') return t('Create New List');
    return t('Select Recipients');
  }, [mode, t]);

  const backAction = useMemo(() => {
    switch (mode) {
      case 'recipients-edit-list':
        return cancelEditList;
      case 'recipients-select-list':
        return cancelCreateList;
      default:
        return undefined;
    }
  }, [mode, cancelEditList, cancelCreateList]);

  return <AudienceTray.Header title={title} onBackClick={backAction} />;
};
